import { z } from "zod";

import { fetchWithError, useParsedQueries, useParsedQuery } from "@nens/react-query-utils";
import { combineUrlAndParams } from "@nens/shared-utils";

import { paginatedSchema } from "../pagination";

import { baseAssetSchema } from "./assetsBase";

export const outletListItemSchema = baseAssetSchema.extend({
  manhole: z.string().nullable() /* URL */,
  connection_serial: z.number().nullable(),
  open_water_level_average: z.number().nullable(),
  open_water_level_summer: z.number().nullable(),
  open_water_level_winter: z.number().nullable(),
});

export type OutletListItem = z.infer<typeof outletListItemSchema>;

export const outletListSchema = paginatedSchema(outletListItemSchema);
export type OutletList = z.infer<typeof outletListSchema>;

export const outletSchema = outletListItemSchema;
export type Outlet = z.infer<typeof outletSchema>;

export function useOutlets(params = {}) {
  const url = combineUrlAndParams("/api/v4/outlets/", params);
  return useParsedQuery<OutletList>(
    ["lizard-api-v4", "outlets", url],
    () => fetchWithError(url),
    (json: unknown) => outletListSchema.parse(json)
  );
}

export function useOutlet(id: number) {
  return useParsedQuery<Outlet>(
    ["lizard-api-v4", "outlets", id],
    () => fetchWithError(`/api/v4/outlets/${id}/`),
    (json: unknown) => outletSchema.parse(json)
  );
}

export function useMultipleOutlets(ids: number[]) {
  return useParsedQueries(
    ids.map((id) => {
      return {
        queryKey: ["lizard-api-v4", "outlets", id],
        fetchFunction: () => fetchWithError(`/api/v4/outlets/${id}/`),
        parseFunction: (json: unknown) => outletSchema.parse(json),
      };
    })
  );
}
